import React from 'react';
import Modal from 'components/Modal';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Settings/FirstUsageSettings/styles';
import { IconWrapper } from 'Settings/Section/styles';
import { ApButtonIcon, ApIcon, colors } from '@alixpartners/ui-components';
import { Backdrop, ModalNameContainer, ModalHeader } from './components.styles';

const ModuleNameModal = ({ children, onClose, title }) => {
	return (
		<Backdrop>
			<ModalNameContainer>
				<ModalHeader>
					<div>{title}&nbsp;</div>
					<ApButtonIcon
						title="Close"
						iconName="close"
						onClick={() => onClose(false)}
					/>
				</ModalHeader>
				{children}
			</ModalNameContainer>
		</Backdrop>
		// <Modal
		// width={450}
		// 	onClose={() => onClose(false)}
		// zIndex="100"
		// 	title={title ? <span style={{display:"flex"}}>{title }&nbsp; <Tooltip
		// 	position="bottom"
		// 	animation="fade"

		// 	arrow
		// 	html={<TooltipContent>
		// 		Apply Filter will Apply the current selected filters on the SKU Raw Table.<br />
		// 		<br />
		// 		Clicking on Generate Analysis Module Button Will generate a tab in Segmented Data Module
		// 	</TooltipContent>}
		// 	trigger="mouseenter"
		// >
		// 	<IconWrapper>
		// 		<ApIcon
		// 			iconName="baseline_help"
		// 			iconSize={16}
		// 			iconColor={colors.grey6}
		// 		/>
		// 	</IconWrapper>
		// </Tooltip></span> : 'Tiltle'}
		// >
		// 	{children}
		// </Modal>
	);
};

export default ModuleNameModal;
